import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import {
  isSafeTextInput,
  NO_SCRIPT_INPUT_MESSAGE,
} from '../validators/no-script-input.validator';

@Directive({
  selector:
    'input[type=text],input[type=search],input[type=email],input[type=url],input:not([type]),textarea',
})
export class NoScriptInputDirective implements OnInit {
  constructor(private elementRef: ElementRef<HTMLInputElement | HTMLTextAreaElement>) {}

  ngOnInit(): void {
    this.validate(this.elementRef.nativeElement.value);
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    this.validate((event.target as HTMLInputElement | HTMLTextAreaElement).value);
  }

  @HostListener('blur', ['$event'])
  onBlur(event: Event): void {
    this.validate((event.target as HTMLInputElement | HTMLTextAreaElement).value);
  }

  private validate(value: string): void {
    const element = this.elementRef.nativeElement;

    if (isSafeTextInput(value)) {
      element.setCustomValidity('');
      return;
    }

    element.setCustomValidity(NO_SCRIPT_INPUT_MESSAGE);
  }
}
